import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";

const useRouter = () => {
  const params = useParams();
  const location = useLocation();

  const data = useMemo(
    () => ({
      pathname: location.pathname,
      search: location.search,
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      location,
    }),
    [params, location]
  );

  return data;
};

export default useRouter;
